/**
 * PostHog WOM (Word of Mouth) event tracking – INHANSS
 * Standardized naming: wom_<section>_<action>_<page>
 * Page is detected from URL; no hardcoded page names in event strings.
 * Uses capture-phase + composedPath() for Shadow DOM support.
 */
(function () {
  'use strict';

  // Prevent attaching duplicate listeners if this script is loaded multiple times
  if (typeof window !== 'undefined') {
    if (window.__womPosthogEventsInitialized) {
      return;
    }
    window.__womPosthogEventsInitialized = true;
  }

  var ACTION_CLICKED = 'clicked';
  var ACTION_VIEWED = 'viewed';
  var ACTION_VIDEO_PLAYED = 'video_played';

  /**
   * Detect page type from URL path.
   * "/" → home, "/collections" → collection, "/products" → pdp, else "other"
   */
  function getWomPageType() {
    if (typeof window === 'undefined' || !window.location || !window.location.pathname) {
      return 'other';
    }
    var path = window.location.pathname;
    if (path === '/' || path === '') return 'home';
    // Treat any URL that includes \"/products/\" (including /collections/.../products/...) as PDP
    if (path.indexOf('/products/') !== -1) return 'pdp';
    if (path.indexOf('/collections') === 0) return 'collection';
    return 'other';
  }

  function getWomPagePrefix() {
    var page = getWomPageType();
    if (page === 'home') return 'wom_home_';
    if (page === 'collection') return 'wom_plp_';
    if (page === 'pdp') return 'wom_pdp_';
    return 'wom_other_';
  }

  /**
   * Send event to PostHog with standard metadata.
   * Event name: wom_<section>_<action>_<page> (page from getWomPageType).
   */
  function trackWomEvent(section, action, extraProps) {
    action = action || ACTION_CLICKED;
    var page = getWomPageType();
    var eventName = 'wom_' + section + '_' + action + '_' + page;
    var properties = {
      page_type: page,
      section: section,
      url: typeof window !== 'undefined' && window.location ? window.location.href : '',
      timestamp: new Date().toISOString()
    };
    if (extraProps && typeof extraProps === 'object') {
      for (var k in extraProps) {
        if (extraProps.hasOwnProperty(k)) properties[k] = extraProps[k];
      }
    }
    capture(eventName, properties);
  }

  function capture(eventName, properties) {
    try {
      if (typeof window.posthog === 'undefined' || typeof window.posthog.capture !== 'function') return;
      window.posthog.capture(eventName, properties || {});
    } catch (e) {}
  }

  function getText(el) {
    if (!el) return '';
    return (el.textContent || '').trim();
  }

  function getTextUp(el, maxDepth) {
    var depth = maxDepth === undefined ? 5 : maxDepth;
    var node = el;
    while (node && depth-- > 0) {
      var t = getText(node);
      if (t && t.length > 2) return t;
      node = node.parentElement || node.parentNode;
    }
    return getText(el);
  }

  function getPathText(path, maxLen) {
    var out = '';
    var len = maxLen === undefined ? 500 : maxLen;
    for (var i = 0; i < path.length && out.length < len; i++) {
      var node = path[i];
      if (node && node.nodeType === 1) {
        var t = getText(node);
        if (t && t.length < 200) out += ' ' + t;
      }
    }
    return out.trim();
  }

  function getWomWidgetFromPath(path) {
    if (!path || !path.length) return null;
    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (node && node.getAttribute) {
        var w = node.getAttribute('data-wom-widget');
        if (w === 'reviews' || w === 'social-proof' || w === 'rating-breakdown' || w === 'live-users' || w === 'reviews-container') return w;
      }
    }
    return null;
  }

  function pathHas(path, attr, value) {
    if (!path || !path.length) return false;
    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (!node || !node.getAttribute) continue;
      var v = node.getAttribute(attr);
      if (value === undefined || value === '') {
        if (v !== null && v !== undefined) return true;
      } else if (v === value) return true;
    }
    return false;
  }

  function normalizeRatingFilterValue(raw) {
    if (raw === null || raw === undefined) return null;
    var v = String(raw).toLowerCase().replace(/\s+/g, '').trim();
    if (!v) return null;
    if (v === 'all' || v === 'allreviews' || v === 'allreview') return 'all';
    var m = v.match(/^([1-5])/);
    if (m) return m[1];
    return null;
  }

  function getFilterValueFromRatingContext(path, clickEl, target, text, pathText) {
    var i;

    // 1) Explicit attribute from rating row (new JSX widget)
    for (i = 0; i < path.length; i++) {
      var n = path[i];
      if (!n || !n.getAttribute) continue;
      var rowVal = n.getAttribute('data-wom-rating-row');
      var normalizedRow = normalizeRatingFilterValue(rowVal);
      if (normalizedRow) return normalizedRow;
      var starVal = n.getAttribute('data-stars');
      var normalizedStar = normalizeRatingFilterValue(starVal);
      if (normalizedStar) return normalizedStar;
    }

    // 2) Local target/click element attributes
    var directStar = target && target.getAttribute && target.getAttribute('data-stars');
    var normalizedDirectStar = normalizeRatingFilterValue(directStar);
    if (normalizedDirectStar) return normalizedDirectStar;
    var directRow = clickEl && clickEl.getAttribute && clickEl.getAttribute('data-wom-rating-row');
    var normalizedDirectRow = normalizeRatingFilterValue(directRow);
    if (normalizedDirectRow) return normalizedDirectRow;

    // 3) Text fallback
    var filterText = (text || '').replace(/\s+/g, ' ').trim();
    var normalizedText = normalizeRatingFilterValue(filterText);
    if (normalizedText) return normalizedText;
    var starMatch = (pathText || '').match(/\b([1-5])\s*star/i);
    if (starMatch && starMatch[1]) return starMatch[1];

    return null;
  }

  function isInsideReviewsWidget(path) {
    if (getWomWidgetFromPath(path) === 'reviews') return true;
    if (pathHas(path, 'data-wom-rating-breakdown-container') ||
        pathHas(path, 'data-wom-reviews-list-container') ||
        pathHas(path, 'data-wom-reviews-layout') ||
        pathHas(path, 'data-wom-component', 'reviews')) return true;
    return pathHas(path, 'id', 'reviews-pagination') ||
           pathHas(path, 'id', 'review-filters') ||
           pathHas(path, 'id', 'reviews-list');
  }

  /** Section allowed on current page? */
  function isSectionAllowedOnPage(section, page) {
    var allowed = {
      instagram: ['home', 'collection', 'pdp', 'other'],
      reel_section: ['home', 'pdp'],
      store_videos: ['home'],
      inhanss_instasection: ['home'],
      journey_videos: ['home', 'collection', 'pdp'],
      media_section: ['home'],
      circle_videos: ['collection'],
      wom_ai_brand_engine: ['home', 'collection', 'pdp', 'other']
    };
    var pages = allowed[section];
    return pages && pages.indexOf(page) !== -1;
  }

  /** Sanitize video name for event: lowercase, replace spaces with underscore, alphanumeric + underscore only */
  function sanitizeVideoName(name) {
    if (!name || typeof name !== 'string') return 'unknown';
    return name.trim().toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '').slice(0, 50) || 'unknown';
  }

  /** Single delegated click handler: identify WOM section and fire standardized event once */
  document.addEventListener('click', function (e) {
    var target = e.target;
    var path = (e.composedPath && e.composedPath()) || [];
    var clickEl = target && target.nodeType === 1 ? target : (target && (target.parentElement || target.parentNode));
    if (!clickEl || clickEl.nodeType !== 1) clickEl = target;
    var page = getWomPageType();
    var label = (target.getAttribute && target.getAttribute('aria-label')) || '';
    var pagePrefix = getWomPagePrefix();
    var btn = clickEl.closest && (clickEl.closest('button') || clickEl.closest('a') || clickEl.closest('[role="button"]'));
    if (btn) label = label || (btn.getAttribute && btn.getAttribute('aria-label')) || '';
    var text = getTextUp(btn || target) || getText(target);
    var pathText = getPathText(path);

    // —— 1. Instagram (sticky button + modal) ——
    if (clickEl && (clickEl.id === 'instagram-sticky-btn' || (clickEl.className && String(clickEl.className).indexOf('instagram-sticky-button') !== -1))) {
      if (isSectionAllowedOnPage('instagram', page)) {
        trackWomEvent('instagram', ACTION_CLICKED, { action: 'open', source: 'sticky_button' });
      }
      return;
    }
    if (clickEl && clickEl.closest && clickEl.closest('.instagram-modal')) {
      var isModalClose = clickEl.closest('.instagram-modal-close') || clickEl.id === 'instagram-modal-close' || label === 'Close modal';
      var isNav = clickEl.closest('.instagram-nav-btn');
      if (isModalClose) {
        capture('wom_instagram_modal_closed', { source: 'wom_instagram_modal' });
        return;
      }
      if (isNav) {
        capture('wom_instagram_modal_nav_clicked', { direction: clickEl.id === 'instagram-nav-up' ? 'prev' : 'next' });
        return;
      }
      if (isSectionAllowedOnPage('instagram', page)) {
        trackWomEvent('instagram', ACTION_CLICKED, { source: 'modal' });
      }
      return;
    }

    // —— 2. Reel section (Watch it Styled) – Home + PDP ——
    if (clickEl && clickEl.closest && (clickEl.closest('.wom-reels-section') || clickEl.closest('.wom-reels-modal') || clickEl.closest('.wom-reels-grid'))) {
      if (isSectionAllowedOnPage('reel_section', page)) {
        trackWomEvent('reel_section', ACTION_CLICKED);
      }
      return;
    }

    // —— 3. INHANSS in Real Life (video pills) – Home only ——
    if (clickEl && clickEl.closest && (clickEl.closest('.wom-video-pills-section') || clickEl.closest('.wom-video-pills-modal') || clickEl.closest('#wom-video-pills-container'))) {
      if (page === 'home') {
        trackWomEvent('store_videos', ACTION_CLICKED, { page_type: 'home' });
      }
      return;
    }

    // —— 4. INHANSS Instagram Section (profile block) – Home only ——
    if (clickEl && clickEl.closest && clickEl.closest('.wom-instagram-profile-section')) {
      if (page === 'home') {
        trackWomEvent('inhanss_instasection', ACTION_CLICKED, { page_type: 'home' });
      }
      return;
    }

    // —— 5. The INHANSS Journey (video gallery) – Home + Collection + PDP ——
    if (clickEl && clickEl.closest && (clickEl.closest('.wom-video-gallery-section') || clickEl.closest('.wom-video-gallery-modal') || clickEl.closest('#wom-video-gallery-container'))) {
      if (isSectionAllowedOnPage('journey_videos', page)) {
        trackWomEvent('journey_videos', ACTION_CLICKED);
      }
      return;
    }

    // —— 6. As Seen In Media – Home only ——
    if (clickEl && clickEl.closest && clickEl.closest('.inhanss-media-section')) {
      if (page === 'home') {
        trackWomEvent('media_section', ACTION_CLICKED, { page_type: 'home' });
      }
      return;
    }

    // —— 7. Styling Inspiration (circle videos) – Collection only ——
    if (clickEl && clickEl.closest && (clickEl.closest('.wom-styling-videos') || clickEl.closest('#wom-styling-videos-grid') || clickEl.closest('.wom-styling-modal'))) {
      if (page === 'collection') {
        var item = clickEl.closest && clickEl.closest('.wom-styling-videos__item');
        var videoName = item && item.getAttribute && item.getAttribute('data-wom-video-name');
        trackWomEvent('circle_videos', ACTION_CLICKED, { page_type: 'collection' });
        if (videoName) {
          var slug = sanitizeVideoName(videoName);
          capture('wom_circle_video_' + slug + '_clicked_collection', {
            page_type: 'collection',
            section: 'circle_videos',
            video_name: videoName,
            url: window.location ? window.location.href : '',
            timestamp: new Date().toISOString()
          });
        }
      }
      return;
    }

    // —— 8. AI Brand Engine (Why Trust Us) ——
    if (clickEl && clickEl.closest && clickEl.closest('.ai-brand-engine')) {
      var isTrigger = clickEl.closest('.ai-brand-engine-trigger') || clickEl.id === 'abeTrigger' || (btn && (btn.id === 'abeTrigger' || (btn.className && String(btn.className).indexOf('ai-brand-engine-trigger') !== -1)));
      var isClose = clickEl.closest('.panel-close-btn') || clickEl.id === 'abeClose' || (btn && btn.id === 'abeClose');
      if (isTrigger) {
        trackWomEvent('wom_ai_brand_engine', ACTION_CLICKED, { action: 'open' });
        return;
      }
      if (isClose) {
        capture('wom_ai_brand_engine_closed', { page_type: page, section: 'wom_ai_brand_engine', url: window.location ? window.location.href : '', timestamp: new Date().toISOString() });
        return;
      }
      trackWomEvent('wom_ai_brand_engine', ACTION_CLICKED, { action: 'panel_interaction' });
      return;
    }

    // —— Legacy / non-section WOM and e‑commerce (unchanged naming) ——
    if (label === 'Previous image' || (btn && btn.getAttribute && btn.getAttribute('aria-label') === 'Previous image')) {
      capture('wom_review_image_prev_clicked', {});
      return;
    }
    if (label === 'Next image' || (btn && btn.getAttribute && btn.getAttribute('aria-label') === 'Next image')) {
      capture('wom_review_image_next_clicked', {});
      return;
    }

    var draggableVideo = clickEl && clickEl.closest && (clickEl.closest('.draggable-video-wrapper') || clickEl.closest('#draggable-video-container') || clickEl.closest('.draggable-video-player'));
    if (draggableVideo) {
      var dvContainer = clickEl.closest && (clickEl.closest('#draggable-video-container') || clickEl.closest('.draggable-video-wrapper'));
      var productHandle = (dvContainer && dvContainer.getAttribute && dvContainer.getAttribute('data-product-handle')) || '';
      capture('wom_draggable_video_clicked', { source: 'draggable_video_player', productHandle: productHandle });
      return;
    }

    if (clickEl && clickEl.closest && clickEl.closest('.wom-mkt-trust')) {
      capture('wom_trust_badge_clicked', { source: 'marketplace_trust_badge' });
      return;
    }

    // Video section nav/close (reels, pills, gallery) – already handled above with trackWomEvent; optional legacy props
    var sectionEl = null;
    var eventBase = null;
    var isPrev = false, isNext = false, isClose = false;
    if (clickEl && clickEl.closest) {
      if (clickEl.closest('.wom-video-stories-section') || clickEl.closest('.wom-video-stories-modal')) {
        sectionEl = clickEl.closest('.wom-video-stories-section') || clickEl.closest('.wom-video-stories-modal');
        eventBase = 'wom_video_stories';
        isClose = clickEl.closest('.wom-video-stories-modal-close') || label === 'Close video';
        isPrev = clickEl.closest('[aria-label="Previous"]') || label === 'Previous';
        isNext = clickEl.closest('[aria-label="Next"]') || label === 'Next';
      } else if (clickEl.closest('.wom-video-pills-section') || clickEl.closest('.wom-video-pills-modal')) {
        sectionEl = clickEl.closest('.wom-video-pills-section') || clickEl.closest('.wom-video-pills-modal');
        eventBase = 'wom_video_pills';
        isClose = clickEl.closest('#wom-close-carousel') || clickEl.id === 'wom-close-carousel' || label === 'Close';
        isPrev = clickEl.closest('#wom-carousel-prev') || clickEl.closest('.wom-video-nav-prev') || label === 'Previous';
        isNext = clickEl.closest('#wom-carousel-next') || clickEl.closest('.wom-video-nav-next') || label === 'Next';
      } else if (clickEl.closest('.wom-video-gallery-section') || clickEl.closest('.wom-video-gallery-modal')) {
        sectionEl = clickEl.closest('.wom-video-gallery-section') || clickEl.closest('.wom-video-gallery-modal');
        eventBase = 'wom_video_gallery';
        isClose = clickEl.closest('.wom-video-gallery-modal-close') || label === 'Close video';
        isPrev = label === 'Previous' || (btn && getText(btn).toLowerCase().indexOf('prev') !== -1);
        isNext = label === 'Next' || (btn && getText(btn).toLowerCase().indexOf('next') !== -1);
      } else if (clickEl.closest('.wom-reels-section') || clickEl.closest('.wom-reels-modal')) {
        sectionEl = clickEl.closest('.wom-reels-section') || clickEl.closest('.wom-reels-modal');
        eventBase = 'wom_reels';
        isClose = clickEl.closest('.wom-reels-modal-close') || label === 'Close';
        isPrev = label === 'Previous' || (btn && getText(btn).toLowerCase().indexOf('prev') !== -1);
        isNext = label === 'Next' || (btn && getText(btn).toLowerCase().indexOf('next') !== -1);
      }
    }
    if (eventBase) {
      var props = { page_type: page, url: window.location ? window.location.href : '' };
      if (isPrev) { capture(eventBase + '_prev_clicked', props); return; }
      if (isNext) { capture(eventBase + '_next_clicked', props); return; }
      if (isClose) { capture(eventBase + '_close_clicked', props); return; }
      capture(eventBase + '_clicked', props);
      return;
    }

    // Widgets / other sections (no standardized section name in spec; keep legacy)
    if (clickEl && clickEl.closest && clickEl.closest('.wom-widgets-section')) {
      capture('wom_widgets_clicked', { page_type: page });
      return;
    }
    if (clickEl && clickEl.closest && (clickEl.closest('.wom-widgets-loader-section') || (clickEl.className && String(clickEl.className).indexOf('wom-widgets-loader') !== -1))) {
      capture('wom_widgets_loader_clicked', { page_type: page });
      return;
    }

    // Styling videos modal nav/close (when not on collection we still log generic styling click)
    if (clickEl && clickEl.closest && (clickEl.closest('.wom-styling-modal__close') || clickEl.closest('#wom-styling-prev') || clickEl.closest('#wom-styling-next'))) {
      var which = clickEl.closest('.wom-styling-modal__close') ? 'close' : clickEl.closest('#wom-styling-prev') ? 'prev' : 'next';
      capture('wom_styling_videos_' + which + '_clicked', { page_type: page });
      return;
    }

    // Header login
    var accountLink = clickEl && clickEl.closest && clickEl.closest('a');
    if (accountLink && accountLink.getAttribute('href') && (accountLink.getAttribute('href') || '').indexOf('/account') !== -1) {
      var inHeader = accountLink.closest && (accountLink.closest('.header__account-link') || accountLink.closest('header') || accountLink.closest('header-sidebar') || accountLink.closest('#sidebar-menu'));
      if (inHeader) {
        var isLogin = (accountLink.getAttribute('href') || '').indexOf('/account/login') !== -1;
        capture('login_clicked', { source: 'header', isLogin: isLogin });
        return;
      }
    }

    // Cart drawer close / continue shopping
    function pathContainsCartDrawer(p) {
      if (!p || !p.length) return false;
      for (var i = 0; i < p.length; i++) {
        var n = p[i];
        if (n && (n.id === 'cart-drawer' || (n.tagName && n.tagName.toLowerCase() === 'cart-drawer') || (n.className && String(n.className).indexOf('cart-drawer') !== -1))) return true;
      }
      return false;
    }
    var inCartDrawer = pathContainsCartDrawer(path);
    var combinedText = (text + ' ' + pathText).toLowerCase();
    if (inCartDrawer) {
      var isCloseBtn = label === 'Close' || (label && label.toLowerCase().indexOf('close') !== -1) || (clickEl && clickEl.closest && clickEl.closest('dialog-close-button'));
      var isContinueShopping = /continue\s*shopping/i.test(text) || /continue\s*shopping/i.test(pathText);
      if (isCloseBtn || isContinueShopping) {
        capture('cancel_purchase_clicked', { source: isCloseBtn ? 'cart_drawer_close' : 'continue_shopping' });
        return;
      }
    }
    if (typeof window !== 'undefined' && window.location && (window.location.pathname === '/cart' || window.location.pathname.indexOf('/cart') !== -1)) {
      if (/continue\s*shopping/i.test(text) || /continue\s*shopping/i.test(pathText)) {
        capture('cancel_purchase_clicked', { source: 'cart_page_continue_shopping' });
        return;
      }
    }

    function getProductContextFromForm(form) {
      var ctx = { productHandle: '', variantId: '' };
      if (!form) return ctx;
      var idInput = form.querySelector && form.querySelector('input[name="id"]');
      if (idInput && idInput.value) ctx.variantId = String(idInput.value);
      var picker = form.querySelector && form.querySelector('variant-picker[handle]');
      if (picker && picker.getAttribute('handle')) ctx.productHandle = picker.getAttribute('handle');
      if (!ctx.productHandle && typeof window.location !== 'undefined' && window.location.pathname) {
        var m = window.location.pathname.match(/\/products\/([^\/\?]+)/);
        if (m) ctx.productHandle = m[1];
      }
      if (!ctx.productHandle && form.closest) {
        var card = form.closest('.product-card') || form.closest('product-card');
        if (card && card.getAttribute && card.getAttribute('handle')) ctx.productHandle = card.getAttribute('handle');
      }
      return ctx;
    }

    var inPaymentButton = path.some(function (node) {
      return node && node.classList && node.classList.contains && (node.classList.contains('shopify-payment-button') || node.classList.contains('shopify-payment-button__button'));
    });
    if (inPaymentButton) {
      var payForm = (target.closest && target.closest('form')) || (btn && btn.closest && btn.closest('form'));
      var payCtx = getProductContextFromForm(payForm);
      // Standardized WOM event: wom_buy_now_clicked_<page>
      trackWomEvent('buy_now', ACTION_CLICKED, {
        productHandle: payCtx.productHandle,
        variantId: payCtx.variantId
      });
      // Backwards-compatible legacy name
      capture('buy_now_clicked', { productHandle: payCtx.productHandle, variantId: payCtx.variantId });
      return;
    }

    var submitEl = clickEl && clickEl.closest && (clickEl.closest('button[type="submit"]') || clickEl.closest('input[type="submit"]'));
    if (submitEl && submitEl.form) {
      var form = submitEl.form;
      var action = (form.action || form.getAttribute('action') || '').toLowerCase();
      var isCartAdd = action.indexOf('cart/add') !== -1 || action.indexOf('/cart/add') !== -1;
      var insidePay = form.querySelector && form.querySelector('.shopify-payment-button') && (form.querySelector('.shopify-payment-button').contains(target) || form.querySelector('.shopify-payment-button').contains(submitEl));
      if (!insidePay && isCartAdd) {
        var atcCtx = getProductContextFromForm(form);
        capture('add_to_cart_clicked', { productHandle: atcCtx.productHandle, variantId: atcCtx.variantId });
        return;
      }
    }

    var collectionRatingEl = clickEl && clickEl.closest && clickEl.closest('.wom-collection-rating');
    if (collectionRatingEl) {
      var crHandle = (collectionRatingEl.getAttribute && collectionRatingEl.getAttribute('data-product-handle')) || '';
      capture('wom_collection_rating_clicked', { source: 'wom_collection_rating', productHandle: crHandle });
      return;
    }

    var card = target.closest && (target.closest('.product-card') || target.closest('product-card') || target.closest('.t4s-col-item') || target.closest('[data-product-handle]'));
    if (!card && target.closest) {
      var productLink = target.closest('a');
      if (productLink && productLink.getAttribute && (productLink.getAttribute('href') || '').indexOf('/products/') !== -1) card = productLink;
    }
    if (card) {
      var ratingEl = card.querySelector && card.querySelector('.wom-collection-rating');
      var hasWomInCard = ratingEl && (ratingEl.style.display === 'flex' || (window.getComputedStyle && window.getComputedStyle(ratingEl).display === 'flex'));
      if (hasWomInCard) {
        var handle = (ratingEl && ratingEl.getAttribute && ratingEl.getAttribute('data-product-handle')) || (card.getAttribute && card.getAttribute('handle')) || (card.getAttribute && card.getAttribute('data-product-handle')) || '';
        var title = (ratingEl && ratingEl.getAttribute && ratingEl.getAttribute('data-product-title')) || (card.querySelector && getText(card.querySelector('.product-title'))) || '';
        if (!handle && card.getAttribute && card.getAttribute('href')) {
          var hm = (card.getAttribute('href') || '').match(/\/products\/([^\/\?]+)/);
          if (hm) handle = hm[1];
        }
        capture('wom_product_card_clicked', { productHandle: handle, productTitle: title });
        return;
      }
    }

    if (getWomWidgetFromPath(path) === 'social-proof' || pathHas(path, 'data-wom-component', 'social-proof')) {
      capture('wom_social_proof_clicked', { source: 'wom_social_proof' });
      return;
    }

    if (clickEl && clickEl.closest && (clickEl.closest('#reviews-breakdown-detailed') || clickEl.closest('.metric-badge') || clickEl.closest('.fit-row') || clickEl.closest('#rating-bars-detailed') || clickEl.closest('.jewelry-gallery-container') || clickEl.closest('[data-wom-rating-row]'))) {
      var detailedFilterValue = getFilterValueFromRatingContext(path, clickEl, target, text, pathText);
      var detailedFilterName = detailedFilterValue === 'all' ? 'all' : (detailedFilterValue ? detailedFilterValue + 'star' : null);

      capture('wom_reviews_breakdown_detailed_clicked', {
        source: 'wom_reviews_breakdown_detailed',
        filterValue: detailedFilterValue,
        filter_name: detailedFilterName
      });

      if (detailedFilterValue) {
        capture('wom_filter_changed', {
          filterValue: detailedFilterValue,
          filter_name: detailedFilterName
        });

        var dfLower = String(detailedFilterValue).toLowerCase();
        var dfStarMatch = dfLower.match(/^([1-5])/);
        if (dfStarMatch) {
          var dfStarVal = dfStarMatch[1];
          var dfPageType = typeof getWomPageType === 'function' ? getWomPageType() : undefined;
          capture('wom_' + dfStarVal + 'star_filter', {
            page_type: dfPageType,
            section: 'rating_breakdown',
            filterValue: dfStarVal,
            filter_name: dfStarVal + 'star',
            url: typeof window !== 'undefined' && window.location ? window.location.href : '',
            timestamp: new Date().toISOString()
          });
        }

        var detailedPageCtx = typeof getWomPageType === 'function' ? getWomPageType() : 'other';
        var detailedPrefix = getWomPagePrefix ? getWomPagePrefix() : '';
        capture(detailedPrefix + 'rating_breakdown_clicked', {
          page_type: detailedPageCtx,
          filterValue: detailedFilterValue,
          filter_name: detailedFilterName
        });
      }
      return;
    }

    if (getWomWidgetFromPath(path) === 'reviews-container' || pathHas(path, 'data-wom-widget', 'reviews-container') || (clickEl && clickEl.closest && clickEl.closest('.wom-reviews-container'))) {
      capture('wom_reviews_container_clicked', { source: 'wom_reviews_container' });
      return;
    }

    if (getWomWidgetFromPath(path) === 'live-users' || pathHas(path, 'data-wom-widget', 'live-users')) {
      capture('wom_live_users_clicked', { source: 'wom_live_users' });
      return;
    }

    if (clickEl && (clickEl.id === 'floating-live-counter' || (clickEl.closest && clickEl.closest('#floating-live-counter')))) {
      capture('wom_live_counter_floating_clicked', { source: 'wom_live_counter_floating' });
      return;
    }

    // Load more photos button inside \"all photos\" modal – this lives outside the main reviews widget,
    // so handle it BEFORE we enforce isInsideReviewsWidget.
    var loadMorePhotosBtn = clickEl && clickEl.closest && clickEl.closest('[data-wom-all-photos-load-more]');
    if (loadMorePhotosBtn) {
      var lmCount = 0;
      var lmFilter = null;
      try {
        if (typeof window !== 'undefined' && Array.isArray(window.womAllImages)) {
          lmCount = window.womAllImages.length;
        }
        if (typeof window !== 'undefined' && typeof window.womReviewFilter !== 'undefined') {
          lmFilter = window.womReviewFilter || 'all';
        }
      } catch (eLm) {}
      trackWomEvent('customer_photos', 'load_more', {
        total_images: lmCount,
        current_filter: lmFilter
      });
      return;
    }

    // From here we only care about clicks inside the reviews widget
    if (!isInsideReviewsWidget(path)) return;

    // AI summary read more / read less (inside reviews widget)
    var aiToggleBtn = clickEl && clickEl.closest && clickEl.closest('[data-ai-summary-toggle="true"]');
    if (aiToggleBtn) {
      var aiBtnText = (getText(aiToggleBtn) || '').toLowerCase();
      if (aiBtnText.indexOf('read more') !== -1) {
        capture('wom_ai_summary_readmore', {
          page_type: page,
          section: 'ai_summary',
          url: window.location ? window.location.href : '',
          timestamp: new Date().toISOString()
        });
        // Jazz-style event name for parity with jazz_posthog
        capture(pagePrefix + 'ai_insight_read_more_clicked', {
          page_type: page,
          section: 'wom_reviews',
          url: window.location ? window.location.href : '',
          timestamp: new Date().toISOString()
        });
      } else if (aiBtnText.indexOf('read less') !== -1) {
        capture('wom_ai_summary_readless', {
          page_type: page,
          section: 'ai_summary',
          url: window.location ? window.location.href : '',
          timestamp: new Date().toISOString()
        });
        // Jazz-style event name parity for read less
        capture(pagePrefix + 'ai_insight_read_less_clicked', {
          page_type: page,
          section: 'wom_reviews',
          url: window.location ? window.location.href : '',
          timestamp: new Date().toISOString()
        });
      }
      return;
    }

    // Reviews tabs (product / brand / store) – WOM JSX buttons
    var tabButton = clickEl && clickEl.closest && clickEl.closest('[data-wom-review-tab]');
    if (tabButton && tabButton.getAttribute) {
      var tab = tabButton.getAttribute('data-wom-review-tab') || '';
      if (tab === 'product') {
        capture('wom_product_reviews_tab_clicked', {});
        return;
      }
      if (tab === 'brand') {
        capture('wom_brand_reviews_tab_clicked', {});
        return;
      }
      if (tab === 'store') {
        capture('wom_store_tab_clicked', {});
        return;
      }
    }

    // Store button inside Store tab card
    var storeBtn = clickEl && clickEl.closest && clickEl.closest('[data-wom-store-button]');
    if (storeBtn && storeBtn.getAttribute) {
      var storeAction = storeBtn.getAttribute('data-wom-store-button') || 'unknown';
      capture('wom_store_button_clicked', { action: storeAction });
      return;
    }

    // Fallback text-based detection for Brand Reviews / Store tab
    if (/brand\s*reviews?/i.test(text) || /brand\s*reviews?/i.test(pathText) || (combinedText.indexOf('brand') !== -1 && combinedText.indexOf('review') !== -1)) {
      capture('wom_brand_reviews_clicked', {});
      return;
    }
    if (/\bstore\b/i.test(text) || /\bstore\b/i.test(pathText) || /visit\s*store|shop\s*now/i.test(combinedText)) {
      capture('wom_stores_clicked', {});
      return;
    }

    function pathHasSvgPathD(p, leftRight) {
      for (var i = 0; i < p.length; i++) {
        var n = p[i];
        if (!n || n.nodeType !== 1) continue;
        if (n.tagName === 'path' && n.getAttribute) {
          var d = (n.getAttribute('d') || '').replace(/\s+/g, ' ');
          if (leftRight === 'prev' && (d.indexOf('M15 18') !== -1 || d.indexOf('15 18') !== -1)) return true;
          if (leftRight === 'next' && (d.indexOf('M9 18') !== -1 || d.indexOf('9 18') !== -1) && d.indexOf('15') === -1) return true;
        }
        var paths = n.querySelectorAll && n.querySelectorAll('path[d]');
        if (paths) for (var j = 0; j < paths.length; j++) {
          var pd = (paths[j].getAttribute('d') || '').replace(/\s+/g, ' ');
          if (leftRight === 'prev' && (pd.indexOf('M15 18') !== -1 || pd.indexOf('15 18') !== -1)) return true;
          if (leftRight === 'next' && pd.indexOf('M9 18') !== -1 && pd.indexOf('15') === -1) return true;
        }
      }
      return false;
    }
    var btnContent = btn ? (getText(btn) || (btn.innerHTML && btn.innerHTML.replace(/<[^>]+>/g, '').trim()) || '').trim() : '';
    var isPrevBtn = label === 'Previous page' || label === 'Previous Page' || btnContent === '\u2039' || btnContent === '\u00AB' || btnContent === '\u2190' || (btn && btn.innerHTML && btn.innerHTML.indexOf('\u2039') !== -1) || btnContent === '<' || pathHasSvgPathD(path, 'prev');
    var isNextBtn = label === 'Next page' || label === 'Next Page' || btnContent === '\u203A' || btnContent === '\u00BB' || btnContent === '\u2192' || (btn && btn.innerHTML && btn.innerHTML.indexOf('\u203A') !== -1) || btnContent === '>' || pathHasSvgPathD(path, 'next');
    if (btn && (isPrevBtn || isNextBtn) && !pathHas(path, 'data-wom-rating-breakdown-container')) {
      capture('wom_pagination_clicked', { type: 'arrow', direction: isPrevBtn ? 'prev' : 'next', linkText: label || (isPrevBtn ? 'Previous page' : 'Next page') });
      return;
    }
    var pageNum = btn ? getText(btn).trim() : (getText(target) || (clickEl && getText(clickEl)) || '').trim();
    if (btn && /^\d+$/.test(pageNum) && !pathHas(path, 'data-wom-rating-breakdown-container')) {
      capture('wom_pagination_clicked', { type: 'page', page: parseInt(pageNum, 10), linkText: pageNum });
      return;
    }
    var digitText = (clickEl && getText(clickEl)) || (target && getText(target)) || '';
    if (/^\d+$/.test(digitText.trim()) && !pathHas(path, 'data-wom-rating-breakdown-container')) {
      capture('wom_pagination_clicked', { type: 'page', page: parseInt(digitText.trim(), 10), linkText: digitText.trim() });
      return;
    }
    var writeReviewEl = clickEl && clickEl.closest && clickEl.closest('button, a, [role="button"]');
    var writeReviewText = writeReviewEl ? getText(writeReviewEl) : '';
    var isWriteReviewClick = !!(writeReviewEl && /write\s*(a\s*)?review/i.test(writeReviewText));
    if (isWriteReviewClick) {
      // Jazz-style event name for parity with jazz_posthog
      if (page === 'pdp') {
        capture(pagePrefix + 'write_review_clicked', {
          page_type: page,
          section: 'wom_reviews',
          url: window.location ? window.location.href : '',
          timestamp: new Date().toISOString()
        });
      } else {
        capture('wom_write_review_clicked', {});
      }
      return;
    }
    if (pathHas(path, 'data-wom-review-card')) {
      if (target.tagName === 'IMG') {
        capture('wom_review_image_clicked', {});
        return;
      }
      for (var pi = 0; pi < path.length; pi++) {
        var n = path[pi];
        if (n && n.className && typeof n.className === 'string' && n.className.indexOf('wom-review-images-gallery') !== -1) {
          capture('wom_review_image_clicked', {});
          return;
        }
      }
    }
    // View all images (customer photos gallery). Be strict so generic "view all" buttons don't match.
    if (/view\s*all\s*(images?|photos?)/i.test(text) || /view\s*all\s*(images?|photos?)/i.test(pathText)) {
      var imagesCount = 0;
      var sampleUrls = [];
      var currentFilter = null;
      try {
        if (typeof window !== 'undefined' && Array.isArray(window.womAllImages)) {
          imagesCount = window.womAllImages.length;
          for (var si = 0; si < window.womAllImages.length && si < 5; si++) {
            var item = window.womAllImages[si];
            var url = item && typeof item === 'object' ? item.url : item;
            if (typeof url === 'string') sampleUrls.push(url);
          }
        }
        if (typeof window !== 'undefined' && typeof window.womReviewFilter !== 'undefined') {
          currentFilter = window.womReviewFilter || 'all';
        }
      } catch (eViewAll) {}
      // If there are no images at all, do not fire this event to avoid misleading data.
      if (imagesCount <= 0) {
        return;
      }
      capture('wom_view_all_images_clicked', {
        images_count: imagesCount,
        has_images: imagesCount > 0,
        sample_urls: sampleUrls,
        current_filter: currentFilter
      });
      return;
    }
    if (btn || (clickEl && clickEl.tagName === 'A')) {
      var href = (target.getAttribute && target.getAttribute('href')) || (btn && btn.getAttribute && btn.getAttribute('href'));
      var paginationText = getText(btn || clickEl || target);
      var paginationLower = paginationText.toLowerCase();
      if (/next|previous|prev/i.test(paginationText) || (href && /page=|\/page\//.test(href)) || paginationLower.indexOf('load more') !== -1 || paginationLower === 'load more') {
        capture('wom_pagination_clicked', { type: 'link', linkText: paginationText, pageUrl: href || undefined });
        return;
      }
    }
    var filterValue = null;
    if (pathHas(path, 'data-wom-rating-breakdown-container') || pathHas(path, 'data-wom-reviews-list-container') || pathHas(path, 'data-wom-component', 'rating-breakdown')) {
      filterValue = getFilterValueFromRatingContext(path, clickEl, target, text, pathText);
    }
    if (filterValue) {
      var fv = String(filterValue);
      var filterName = fv === 'all' ? 'all' : (fv + 'star');
      capture('wom_filter_changed', { filterValue: fv, filter_name: filterName });

      // Star-specific filter events: wom_5star_filter, wom_4star_filter, etc.
      var fvLower = fv.toLowerCase();
      var starMatch = fvLower.match(/^([1-5])/);
      if (starMatch) {
        var starVal = starMatch[1];
        var pageType = typeof getWomPageType === 'function' ? getWomPageType() : undefined;
        capture('wom_' + starVal + 'star_filter', {
          page_type: pageType,
          section: 'rating_breakdown',
          filterValue: starVal,
          filter_name: starVal + 'star',
          url: typeof window !== 'undefined' && window.location ? window.location.href : '',
          timestamp: new Date().toISOString()
        });
      }

      // Jazz-style generic rating breakdown click event for parity with jazz_posthog
      var pageCtx = typeof getWomPageType === 'function' ? getWomPageType() : 'other';
      var prefix = getWomPagePrefix ? getWomPagePrefix() : '';
      capture(prefix + 'rating_breakdown_clicked', {
        page_type: pageCtx,
        filterValue: fv,
        filter_name: filterName
      });
    }
  }, true);

  // Filter select (change)
  function isWomFilterSelect(select) {
    if (!select || select.tagName !== 'SELECT') return false;
    if (select.className && typeof select.className === 'string') {
      if (select.className.indexOf('wom-filter-select') !== -1 || select.className.indexOf('filter-select') !== -1) return true;
    }
    if (select.id === 'review-filter-below-images' || select.id === 'main-filter') return true;
    if (!select.options || select.options.length < 2) return false;
    var hasAll = false, hasStar = false;
    for (var i = 0; i < select.options.length; i++) {
      var opt = select.options[i];
      var v = (opt.value || '').toLowerCase();
      var t = (opt.textContent || opt.text || '').toLowerCase();
      if (v === 'all' || t.indexOf('all review') !== -1) hasAll = true;
      if (v.indexOf('star') !== -1 || t.indexOf('star') !== -1 || v === 'highest' || v === 'lowest' || v === 'verified') hasStar = true;
    }
    return hasAll && hasStar;
  }
  document.addEventListener('change', function (e) {
    var target = e.target;
    if (!target || target.tagName !== 'SELECT') return;
    if (!isWomFilterSelect(target)) return;
    capture('wom_filter_changed', { filterValue: target.value || 'all' });
  }, true);

  // —— Bonus: scroll_into_view (IntersectionObserver) – lightweight ——
  var observedSections = {};
  function observeWomSection(selector, sectionKey) {
    var el = document.querySelector(selector);
    if (!el || observedSections[sectionKey]) return;
    observedSections[sectionKey] = true;
    var page = getWomPageType();
    var allowed = { reel_section: ['home', 'pdp'], store_videos: ['home'], journey_videos: ['home', 'collection', 'pdp'], media_section: ['home'], circle_videos: ['collection'], inhanss_instasection: ['home'] };
    var pages = allowed[sectionKey];
    if (!pages || pages.indexOf(page) === -1) return;
    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        observer.disconnect();
        trackWomEvent(sectionKey, ACTION_VIEWED);
        break;
      }
    }, { threshold: 0.25, rootMargin: '0px' });
    observer.observe(el);
  }
  if (typeof document.querySelector === 'function') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        observeWomSection('.wom-reels-section', 'reel_section');
        observeWomSection('.wom-video-pills-section', 'store_videos');
        observeWomSection('.wom-video-gallery-section', 'journey_videos');
        observeWomSection('.inhanss-media-section', 'media_section');
        observeWomSection('.wom-styling-videos', 'circle_videos');
        observeWomSection('.wom-instagram-profile-section', 'inhanss_instasection');
      });
    } else {
      observeWomSection('.wom-reels-section', 'reel_section');
      observeWomSection('.wom-video-pills-section', 'store_videos');
      observeWomSection('.wom-video-gallery-section', 'journey_videos');
      observeWomSection('.inhanss-media-section', 'media_section');
      observeWomSection('.wom-styling-videos', 'circle_videos');
      observeWomSection('.wom-instagram-profile-section', 'inhanss_instasection');
    }
  }

  // —— Bonus: video_played (first play in WOM video sections) – lightweight ——
  var videoPlayedSent = {};
  function attachVideoPlayTracking(videoEl, sectionKey) {
    if (!videoEl || videoPlayedSent[videoEl]) return;
    videoPlayedSent[videoEl] = true;
    videoEl.addEventListener('play', function once() {
      videoEl.removeEventListener('play', once);
      if (isSectionAllowedOnPage(sectionKey, getWomPageType())) {
        trackWomEvent(sectionKey, ACTION_VIDEO_PLAYED);
      }
    }, { once: true });
  }
  function findWomVideos() {
    var selectors = [
      { sel: '.wom-reels-section video', section: 'reel_section' },
      { sel: '.wom-video-pills-section video', section: 'store_videos' },
      { sel: '.wom-video-gallery-section video', section: 'journey_videos' },
      { sel: '.wom-styling-videos video', section: 'circle_videos' }
    ];
    for (var i = 0; i < selectors.length; i++) {
      var nodes = document.querySelectorAll(selectors[i].sel);
      for (var j = 0; j < nodes.length; j++) {
        attachVideoPlayTracking(nodes[j], selectors[i].section);
      }
    }
  }
  if (typeof document.querySelectorAll === 'function') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', findWomVideos);
    } else {
      findWomVideos();
    }
  }

  // —— Reviews & social-proof visibility timing (time spent in view) ——
  var womVisibilityState = {
    reviews_section: { inView: false, startTs: 0 },
    social_proof: { inView: false, startTs: 0 }
  };

  function startVisibility(sectionKey) {
    var state = womVisibilityState[sectionKey];
    if (!state || state.inView) return;
    state.inView = true;
    state.startTs = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
  }

  function endVisibility(sectionKey) {
    var state = womVisibilityState[sectionKey];
    if (!state || !state.inView) return;
    var endTs = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
    var durationMs = Math.max(0, Math.round(endTs - state.startTs));
    state.inView = false;
    state.startTs = 0;
    // Send duration event using standardized naming
    try {
      var page = getWomPageType ? getWomPageType() : undefined;
      var props = {
        page_type: page,
        section: sectionKey,
        url: typeof window !== 'undefined' && window.location ? window.location.href : '',
        timestamp: new Date().toISOString(),
        visible_ms: durationMs
      };
      trackWomEvent(sectionKey, ACTION_VIEWED, props);
    } catch (e) {}
  }

  function initVisibilityObserver(selector, sectionKey, threshold) {
    if (typeof document === 'undefined' || typeof IntersectionObserver === 'undefined') return;
    var el = document.querySelector(selector);
    if (!el) return;
    var obs = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        if (entry.isIntersecting) {
          startVisibility(sectionKey);
        } else {
          endVisibility(sectionKey);
        }
      }
    }, { threshold: threshold === undefined ? 0.3 : threshold });
    obs.observe(el);
  }

  function initWomVisibilityTracking() {
    var page = getWomPageType ? getWomPageType() : 'other';
    // Only track detailed visibility timing on PDP, where reviews + social proof actually live
    if (page !== 'pdp') return;

    // Reviews section (main widget)
    initVisibilityObserver('.wom-reviews-section', 'reviews_section', 0.3);
    initVisibilityObserver('[data-wom-widget=\"reviews\"]', 'reviews_section', 0.3);
    // Social proof bar near title
    initVisibilityObserver('[data-wom-widget=\"social-proof\"]', 'social_proof', 0.3);
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initWomVisibilityTracking);
    } else {
      initWomVisibilityTracking();
    }
    if (typeof window !== 'undefined') {
      window.addEventListener('beforeunload', function () {
        endVisibility('reviews_section');
        endVisibility('social_proof');
      });
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') {
          endVisibility('reviews_section');
          endVisibility('social_proof');
        }
      });
    }
  }

  // —— Custom WOM media events (instagram modal + reels autoplay/play) ——
  function asNumber(val) {
    var n = Number(val);
    return Number.isFinite(n) ? n : null;
  }

  if (typeof window !== 'undefined' && window.addEventListener) {
    window.addEventListener('wom-instagram-modal-opened', function (e) {
      var d = (e && e.detail) || {};
      capture('wom_instagram_modal_opened', {
        section: 'instagram',
        card_number: asNumber(d.card_number),
        total_cards: asNumber(d.total_cards),
        page_type: getWomPageType()
      });
    });

    window.addEventListener('wom-instagram-modal-closed', function (e) {
      var d = (e && e.detail) || {};
      capture('wom_instagram_modal_session_closed', {
        section: 'instagram',
        last_card_number: asNumber(d.last_card_number),
        total_cards: asNumber(d.total_cards),
        page_type: getWomPageType()
      });
    });

    window.addEventListener('wom-instagram-nav-clicked', function (e) {
      var d = (e && e.detail) || {};
      capture('wom_instagram_modal_nav_clicked_indexed', {
        direction: d.direction || 'unknown',
        from_card_number: asNumber(d.from_card_number),
        page_type: getWomPageType()
      });
    });

    window.addEventListener('wom-instagram-card-viewed', function (e) {
      var d = (e && e.detail) || {};
      capture('wom_instagram_card_viewed', {
        section: 'instagram',
        card_number: asNumber(d.card_number),
        card_index: asNumber(d.card_index),
        card_type: d.card_type || 'post',
        card_url: d.card_url || '',
        page_type: getWomPageType()
      });
    });

    window.addEventListener('wom-instagram-card-clicked', function (e) {
      var d = (e && e.detail) || {};
      capture('wom_instagram_card_clicked', {
        section: 'instagram',
        card_number: asNumber(d.card_number),
        card_index: asNumber(d.card_index),
        card_type: d.card_type || 'post',
        card_url: d.card_url || '',
        page_type: getWomPageType()
      });
    });

    window.addEventListener('wom-reel-card-clicked', function (e) {
      var d = (e && e.detail) || {};
      capture('wom_reel_card_clicked', {
        section: 'reel_section',
        reel_number: asNumber(d.reel_number),
        reel_index: asNumber(d.reel_index),
        reel_url: d.reel_url || '',
        source: d.source || 'grid',
        page_type: getWomPageType()
      });
    });

    window.addEventListener('wom-reel-autoplay-in-view', function (e) {
      var d = (e && e.detail) || {};
      capture('wom_reel_autoplay_in_view', {
        section: 'reel_section',
        reel_number: asNumber(d.reel_number),
        reel_index: asNumber(d.reel_index),
        reel_url: d.reel_url || '',
        source: d.source || 'grid',
        intersection_ratio: d.intersection_ratio,
        page_type: getWomPageType()
      });
    });

    window.addEventListener('wom-reel-played', function (e) {
      var d = (e && e.detail) || {};
      var pageCtx = getWomPageType();
      capture('wom_reel_played', {
        section: 'reel_section',
        reel_number: asNumber(d.reel_number),
        reel_index: asNumber(d.reel_index),
        reel_url: d.reel_url || '',
        source: d.source || 'grid',
        page_type: pageCtx
      });
      if (isSectionAllowedOnPage('reel_section', pageCtx)) {
        trackWomEvent('reel_section', ACTION_VIDEO_PLAYED, {
          reel_number: asNumber(d.reel_number),
          reel_index: asNumber(d.reel_index),
          reel_url: d.reel_url || '',
          source: d.source || 'grid'
        });
      }
    });

    window.addEventListener('wom-reel-modal-opened', function (e) {
      var d = (e && e.detail) || {};
      capture('wom_reel_modal_opened', {
        section: 'reel_section',
        reel_number: asNumber(d.reel_number),
        reel_index: asNumber(d.reel_index),
        reel_url: d.reel_url || '',
        source: d.source || 'modal',
        page_type: getWomPageType()
      });
    });

    window.addEventListener('wom-reel-modal-closed', function (e) {
      var d = (e && e.detail) || {};
      capture('wom_reel_modal_closed', {
        section: 'reel_section',
        reel_number: asNumber(d.reel_number),
        reel_index: asNumber(d.reel_index),
        source: d.source || 'modal',
        page_type: getWomPageType()
      });
    });
  }
})();
